import styles from "./index.module.css";
import PreAndNext from "../preAndNext";
import Subscribe from "../subscribe";
import BuyCard from "../buyCard";

const Detail = (
  {
    movieData,
    index,
    isMobile,
    handleNextIndex,
    handleLastIndex,
    pauseVideo,
    setInputFocus,
    playVideo,
    inputFocus,
    inputValue,
    inputStatus,
    setInputValue,
    onSubmit,
    currentIndex,
  }
) => {

  console.log(`Detail${index}重新绘制了`);
  return (
    <>
      <movieData.detail
        index={index}
        isMobile={isMobile}
        handleNextIndex={handleNextIndex}
        handleLastIndex={handleLastIndex}
        pauseVideo={pauseVideo}
        playVideo={playVideo}
        setInputFocus={setInputFocus}
        movieData={movieData}
      />
      <PreAndNext
        handleNextIndex={handleNextIndex}
        handleLastIndex={handleLastIndex}
        playVideo={playVideo}
      />
      <Subscribe
        setInputFocus={setInputFocus}
        inputFocus={inputFocus}
        inputValue={inputValue}
        inputStatus={inputStatus}
        setInputValue={setInputValue}
        onSubmit={onSubmit}
      />
      <BuyCard />
      <div></div>
    </>
  );
};

export default Detail;
